<template>
  <div class="popup filter-popup visible" id="filter-popup">
    <div class="popup-box">
      <div class="title-popup-wrap">
        <span class="reset">reset</span>
        <p class="title">Filter</p>
        <span class="js-close-popup">
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1L1 14" stroke="#4D4D4F" stroke-width="1.5"></path>
                                        <path d="M14 14L1 1" stroke="#4D4D4F" stroke-width="1.5"></path>
                                    </svg>
                                </span>
      </div>
      <div class="filter-popup-item">
        <div class="item-wrap">
          <span>Customer</span>
          <div class="arrow-icon">
            <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
            </svg>
          </div>
        </div>
        <div class="select-result">
          <p></p>
        </div>
        <div class="filter-dropdown-box" style="display: none;">
          <select name="select" class="select select-search select2-hidden-accessible" data-placeholder="Customer" data-select2-id="58" tabindex="-1" aria-hidden="true">
            <option data-select2-id="60"></option>
            <option value="France Televisions">France Televisions</option>
            <option value="Priveet Canal">Priveet Canal</option>
            <option value="ABC Channel">ABC Channel</option>
            <option value="NBC UK">NBC UK</option>
            <option value="Gulli">Gulli</option>
            <option value="France Ô">France Ô</option>
          </select><span class="select2 select2-container select2-container--default" dir="ltr" data-select2-id="59" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-88-container"><span class="select2-selection__rendered" id="select2-select-88-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">Customer</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>
        </div>
      </div>
      <div class="filter-popup-item">
        <div class="item-wrap">
          <span>LX Terminal</span>
          <div class="arrow-icon">
            <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
            </svg>
          </div>
        </div>
        <div class="select-result">
          <p></p>
        </div>
        <div class="filter-dropdown-box" style="display: none;">
          <select name="select" class="select select-search select2-hidden-accessible" data-placeholder="LX Terminal" data-select2-id="61" tabindex="-1" aria-hidden="true">
            <option data-select2-id="63"></option>
            <option value="Cobham 6075 LX">Cobham 6075 LX</option>
            <option value="Paradigm Hornet 100GX">Paradigm Hornet 100GX</option>
            <option value="Cobham 5075 GX">Cobham 5075 GX</option>
            <option value="Paradigm Connect 100T">Paradigm Connect 100T</option>
          </select><span class="select2 select2-container select2-container--default" dir="ltr" data-select2-id="62" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-qz-container"><span class="select2-selection__rendered" id="select2-select-qz-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">LX Terminal</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>
        </div>
      </div>
      <div class="filter-popup-item">
        <div class="item-wrap">
          <span>Core Module ID</span>
          <div class="arrow-icon">
            <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
            </svg>
          </div>
        </div>
        <div class="select-result">
          <p></p>
        </div>
        <div class="filter-dropdown-box" style="display: none;" data-select2-id="80">
          <select name="select" class="select select-search select2-hidden-accessible" data-placeholder="Core Module ID" data-select2-id="64" tabindex="-1" aria-hidden="true">
            <option data-select2-id="66"></option>
            <option value="CQARBCUYRSQUC===" data-select2-id="83">CQARBCUYRSQUC===</option>
            <option value="CQAKOMVXLSRDK===" data-select2-id="84">CQAKOMVXLSRDK===</option>
            <option value="CQASYH4RLXOFQ===" data-select2-id="85">CQASYH4RLXOFQ===</option>
            <option value="CQASYH4RLXOFQ===" data-select2-id="86">CQASYH4RLXOFQ===</option>
          </select><span class="select2 select2-container select2-container--default select2-container--below" dir="ltr" data-select2-id="65" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-yt-container"><span class="select2-selection__rendered" id="select2-select-yt-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">Core Module ID</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>
        </div>
      </div>
      <div class="filter-popup-item">
        <div class="item-wrap">
          <span>Active Subscription</span>
          <div class="arrow-icon">
            <svg width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.796143 2.31541L2.50819 0.251343L9.49999 6.78477L16.4918 0.251343L18.2038 2.31541L9.49999 10.4487L0.796143 2.31541Z" fill="#00AF41"></path>
            </svg>
          </div>
        </div>
        <div class="select-result">
          <p></p>
        </div>
        <div class="filter-dropdown-box" style="display: none;">
          <select name="select" class="select select-search select2-hidden-accessible" data-placeholder="Phone number" data-select2-id="67" tabindex="-1" aria-hidden="true">
            <option data-select2-id="69"></option>
            <option value="LX EVENT-512/4096 24M">LX EVENT-512/4096 24M</option>
            <option value="LX EVENT-512/4096 24M">LX EVENT-512/4096 24M</option>
            <option value="LX EVENT-512/4096 24M">LX EVENT-512/4096 24M</option>
            <option value="LX EVENT-512/4096 24M">LX EVENT-512/4096 24M</option>
          </select><span class="select2 select2-container select2-container--default" dir="ltr" data-select2-id="68" style="width: auto;"><span class="selection"><span class="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-select-kv-container"><span class="select2-selection__rendered" id="select2-select-kv-container" role="textbox" aria-readonly="true"><span class="select2-selection__placeholder">Phone number</span></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>
        </div>
      </div>
      <div class="filter-popup-item">
        <div class="item-wrap">
          <span>Date of creation</span>
          <div class="calendar-icon">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.166 4.00004H17.4993C17.7204 4.00004 17.9323 4.08784 18.0886 4.24412C18.2449 4.4004 18.3327 4.61236 18.3327 4.83337V18.1667C18.3327 18.3877 18.2449 18.5997 18.0886 18.756C17.9323 18.9122 17.7204 19 17.4993 19H2.49935C2.27834 19 2.06637 18.9122 1.91009 18.756C1.75381 18.5997 1.66602 18.3877 1.66602 18.1667V4.83337C1.66602 4.61236 1.75381 4.4004 1.91009 4.24412C2.06637 4.08784 2.27834 4.00004 2.49935 4.00004H5.83268V2.33337H7.49935V4.00004H12.4993V2.33337H14.166V4.00004ZM12.4993 5.66671H7.49935V7.33337H5.83268V5.66671H3.33268V9.00004H16.666V5.66671H14.166V7.33337H12.4993V5.66671ZM16.666 10.6667H3.33268V17.3334H16.666V10.6667Z" fill="#00AF41"></path>
            </svg>
          </div>
        </div>
        <div class="select-result">
          <div class="date-time-block from">
            <p class="date"></p>
            <p class="time"></p>
          </div>
          <div class="date-time-block to">
            <p class="date"></p>
            <p class="time"></p>
          </div>
        </div>
        <div class="filter-dropdown-box" style="display: none;">
          <div class="filter-date-time-box from">
            <div class="field date filter-wrap-date">
              <label class="field-name">From</label>
              <input type="text" class="form-control datepicker" readonly="">
            </div>
            <div class="field time filter-wrap-time">
              <input type="text" class="form-control timepicker" readonly="">
            </div>

          </div>
          <div class="filter-date-time-box to">
            <div class="field date filter-wrap-date">
              <label class="field-name">To</label>
              <input type="text" class="form-control datepicker" readonly="">
            </div>
            <div class="field time filter-wrap-time">
              <input type="text" class="form-control timepicker" readonly="">
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <span href="" class="btn light-green js-close-popup reset">Cancel</span>
        <span class="btn success submit">Submit</span>
      </div>
    </div>
  </div>
</template>

<script>

import {mapMutations,/* mapActions,*/ mapState} from "vuex"

export default {
    name: 'customer-filter-form',


    data () {
        return {

        }
    },

    components: {
        //IconSuccess,
        /*IconSuccess, IconDeny, IconBase*//*IconDeny, IconBase*/},

    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    mounted() {
    },

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent'
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
